import PropTypes from "prop-types";
import { FormCalendar, FormDropdown } from "../../components/formElement";

import { classNames } from "primereact/utils";

function getDateLimit({ key, filterData }) {
  return key && filterData[key] ? new Date(filterData[key]) : null;
}

function renderFilterControl({ ui, uiClassName, params, filterData, changeFilter }) {
  if (ui === "calendar") {
    return (
      <FormCalendar
        key={params.key ?? ui}
        className={classNames("p-sm", uiClassName)}
        isControl={false}
        data={{
          ...params,
          elValue: filterData[params.name],
          elChange: changeFilter,
          minDate: getDateLimit({ key: params.minKey, filterData }),
          maxDate: getDateLimit({ key: params.maxKey, filterData }),
        }}
      />
    );
  }

  if (ui === "dropdown") {
    return (
      <FormDropdown
        key={params.key ?? ui}
        className={classNames("p-sm", uiClassName ?? "")}
        isControl={false}
        data={{
          ...params,
          elValue: filterData[params.name],
          elChange: changeFilter,
        }}
      />
    );
  }

  return null;
}

export default function ModuleSearchFilterItem({
  filterData,
  changeFilter,
  options: {
    ui,
    className = "",
    uiClassName = "",
    label = "",
    params = {},
  } = {},
} = {}) {
  return (
    <div className={classNames("flex align-items-center mr-3", className)}>
      <label className="white-space-nowrap mr-2">{label}</label>

      {renderFilterControl({
        ui,
        uiClassName,
        params,
        filterData,
        changeFilter,
      })}
    </div>
  );
}

ModuleSearchFilterItem.propTypes = {
  changeFilter: PropTypes.func,
  filterData: PropTypes.object,
  options: PropTypes.shape({
    className: PropTypes.string,
    label: PropTypes.node,
    params: PropTypes.object,
    ui: PropTypes.string,
    uiClassName: PropTypes.string,
  }),
};
